import React from 'react'
import { Box, Paper, Skeleton } from '@mui/material'

const Row = () => (
  <Paper
    elevation={0}
    sx={{
      mb: 2,
      p: 2,
      borderRadius: '10px',
      border: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      alignItems: 'center',
      gap: 2,
    }}
  >
    <Skeleton variant='circular' width={58} height={58} />
    <Box sx={{ flex: 1 }}>
      <Skeleton variant='text' width={200} height={28} />
      <Skeleton variant='text' width={260} height={20} />
    </Box>
  </Paper>
)

export const BadgesSkeleton = ({ count = 3 }) => (
  <Box sx={{ py: 2 }}>
    <Skeleton
      variant='rectangular'
      height={84}
      sx={{ borderRadius: '10px', mb: 3 }}
    />
    <Skeleton variant='text' width={220} height={34} sx={{ mb: 2 }} />
    {Array.from({ length: count }).map((_, index) => (
      <Row key={`badges-skeleton-${index}`} />
    ))}
  </Box>
)
